import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { ExternalLinkIcon } from '@/components/icons/external-link';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useAuthenticatedContext } from '@/contexts/auth-context';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

import { AudienceDetails } from './audience-details';
import { CampaignDetails } from './campaign-details';
import { PerformanceStats } from './performance-stats';

export function PoolForm() {
  const intl = useIntl();
  const {
    whoami: { wx_url: wxUrl },
  } = useAuthenticatedContext();
  const { campaign, isFetching } = useEditCampaignContext();
  const poolDetails = campaign?.pool_details;

  // Extract values with fallbacks to avoid optional chaining everywhere
  const campaignType = poolDetails?.campaign_type ?? 'email';
  const audienceName = poolDetails?.audience_details.name ?? '';
  const audienceSize = poolDetails?.audience_details.audience_size ?? 0;
  const matchScore = poolDetails?.audience_details.match_score ?? 0;
  const proximity = poolDetails?.audience_details.proximity;
  const performanceStats = poolDetails?.performance_stats;

  const displayCampaignType =
    campaignType === 'email'
      ? intl.formatMessage({
          defaultMessage: 'Email',
          description: 'Email campaign type option',
        })
      : intl.formatMessage({
          defaultMessage: 'SMS',
          description: 'SMS campaign type option',
        });

  return (
    <>
      <CampaignDetails
        campaignType={campaignType}
        displayCampaignType={displayCampaignType}
        audienceName={audienceName}
        isFetching={isFetching}
      />

      <div className="bg-fx-neutral-200 h-px w-full" />

      <PerformanceStats
        delivered={performanceStats?.delivered}
        opened={performanceStats?.opened}
        clicked={performanceStats?.clicked}
        campaignType={campaignType}
        displayCampaignType={displayCampaignType}
        isFetching={isFetching}
      />

      <div className="bg-fx-neutral-200 h-px w-full" />

      <AudienceDetails
        audienceSize={audienceSize}
        matchScore={matchScore}
        proximity={proximity}
        isFetching={isFetching}
      />

      {wxUrl && (
        <Button type="button" variant="link" className="w-fit">
          <Link
            to={`${wxUrl}/pool/talent`}
            target="_blank"
            className="flex items-center gap-2"
          >
            <ExternalLinkIcon className="text-fx-neutral-600" />
            <Typography variant="subtitle1" className="underline">
              <FormattedMessage
                defaultMessage="Edit audience details"
                description="Edit campaign details"
              />
            </Typography>
          </Link>
        </Button>
      )}
    </>
  );
}
